import React from 'react';

import {createStore, applyMiddleware, compose} from 'redux'
import {Provider} from 'react-redux'
import {Router, Route, IndexRoute, browserHistory} from 'react-router'
import {syncHistoryWithStore, routerMiddleware} from 'react-router-redux'

import thunk from 'redux-thunk'

import mybApp from './../reducers';

import Layout from './Layout';
import Home from './Home/Home';
import Introduction from './Introduction';
import NotFound from './NotFound';
import Performances from './Performances';
import Media from './Media';
import Records from './Media/Records';
import { Albums, Photos } from './Media/Photos';
import Videos, { VideoPlayer } from './Media/Videos';
import Friends from './Friends';
import Hiring from './Hiring';
import Contact from './Contact';

import {fetchAlbums} from '../actions';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(mybApp, /* preloadedState, */ composeEnhancers(
  applyMiddleware(thunk,routerMiddleware(browserHistory))
));


const history = syncHistoryWithStore(browserHistory, store);

store.dispatch(fetchAlbums());

const App = () => {

  return (
    <Provider store={store}>
      <Router history={history} onUpdate={() => window.scrollTo(0, 0)}>
        <Route path="/" component={Layout}>
          <IndexRoute component={Home}/>
          <Route path="/" component={Home}/>
          <Route path="introduction" component={Introduction}/>
          <Route path="performances" component={Performances}/>
          <Route path="media" component={Media}>
            <Route path="records" component={Records}/>
            <Route path="albums" component={Albums}>
              <Route path=":id" component={Photos}/>
            </Route>
            <Route path="videos" component={Videos}>
              <Route path=":id" component={VideoPlayer}/>
            </Route>
          </Route>
          <Route path="friends" component={Friends}/>
          <Route path="hiring" component={Hiring}/>
          <Route path="contact" component={Contact}/>
          <Route path="*" component={NotFound}/>
        </Route>
      </Router>
    </Provider>
  );

};

export default App;





/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/